module.exports = __webpack_public_path__ + "static/media/NETBANKING.6367969d.png";